import Footer from "./components/Footer";
import Header from "./components/Header";
import FloatingActions from "./components/FloatingActions";
import Home from "./components/Home";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Overview from "./pages/about/Overview";
import VisionValue from "./pages/about/Vision & Value";
import ResearchDevelopment from "./pages/about/Research & Development";
import FAQ from "./pages/about/FAQ";
import AdmissionOverview from "./pages/admission/Admission Overview";
import AdmissionProcedure from "./pages/admission/Admission Procedure";
import FAQadmission from "./pages/admission/FAQadmission";
import SchoollifeOverview from "./pages/schoolLife/SchoollifeOverview";
import Sports from "./pages/schoolLife/Sports";
import MusicAndDance from "./pages/schoolLife/MusicAndDance";
import CreativeArts from "./pages/schoolLife/CreativeArts";
import Theatre from "./pages/schoolLife/Theatre";
import ClubsandHousecouncil from "./pages/schoolLife/ClubsandHousecouncil";
import SocialOutreach from "./pages/schoolLife/SocialOutreach";
import Facilities from "./pages/schoolLife/Facilities";
import ParentsAsPartners from "./pages/ParentsCorner/ParentsAsPartners";
import ParentsSpeak from "./pages/ParentsCorner/Parent'sSpeak";
import ReferAFriend from "./pages/ParentsCorner/ReferAFriend";
import ParentSchoolAssociation from "./pages/ParentsCorner/ParentSchoolAssociation";
import ContactUs from "./pages/contact Us/ContactUs";
import NewsandEvents from "./pages/MediaRoom/NewsandEvents";
import Awards from "./pages/MediaRoom/Awards";
import PhotoGallery from "./pages/Activites/PhotoGallery";
import VideoGallery from "./pages/Activites/VideoGallery";
import CbscBoard from "./pages/Academics/Syllabus";
import "bootstrap/dist/css/bootstrap.min.css";
import LearningSystem from "./pages/Academics/LearningSystem";
import Careers from "./pages/Careers/Careers";
import Facilator from "./pages/Academics/Programs";
import DynamicNews from "./components/DynamicNews";
import DynamicBlogs from "./components/DynamicBlogs";
import { useDispatch } from "react-redux";
import { storeContent, storeNews, storeBlogs } from "./state/action";
import { useEffect } from "react";
import axios from "axios";
import DynamicContent from "./components/DynamicComponent";
import InnerGallary from "./pages/Activites/innerGallary";
import Testimonial from "./pages/Testimonial/Testimonial";
import Blogs from "./pages/Blogs/Blogs";
import Arts from "./pages/Activites/Arts";
import Music from "./pages/Activites/Music";
import Dance from "./pages/Activites/Dance";
import Swimming from "./pages/Activites/Swimming";
import Taekwondo from "./pages/Activites/Taekwondo";
import LearningConcepts from "./pages/Academics/LearningConcepts";
import CBSEBoardOfAffiliation from "./pages/Scholastics/CBSEBoardOfAffiliation";
import FacilitatorsDevelopment from "./pages/Scholastics/FacilitatorsDevelopment";
import TheMillenniumLearningSystem from "./pages/Scholastics/TheMillenniumLearningSystem";
import MandatoryDisclosure from "./pages/Mandatory Disclosure/MandatoryDisclosure";
import ScrollToTop from "./ScrollToTop";

function App() {
  const dispatch = useDispatch();

  const fetchContents = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_API_URL}/api/auth/get/getAllCMSMaster`)
      .then((res) => {
        console.log(res.data);
        dispatch(storeContent(res.data));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        console.log("operation done");
      });
  };
  const fetchNews = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_API_URL}/api/auth/get/getallNews`)
      .then((res) => {
        console.log(res.data);
        dispatch(storeNews(res.data));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        console.log("operation done");
      });
  };

  const fetchBlogs = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_API_URL}/api/auth/get/getallblogs`)
      .then((res) => {
        console.log(res.data);
        dispatch(storeBlogs(res.data));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        console.log("operation done");
      });
  };

  useEffect(() => {
    // console.log(process.env.NODE_ENV);
    fetchContents();
    fetchNews();
    fetchBlogs();
  }, []);

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to={"/"} replace />} />

          {/* Legacy Redirects */}
          <Route path="/Home" element={<Navigate to="/" replace />} />
          <Route path="/Home/Overview" element={<Navigate to="/overview" replace />} />
          <Route path="/Home/VisionMission" element={<Navigate to="/vision-values" replace />} />
          <Route path="/Home/ResearchDevelopment" element={<Navigate to="/research-development" replace />} />
          <Route path="/Home/AboutFAQ" element={<Navigate to="/faqs" replace />} />
          <Route path="/Home/AdmissionOverview" element={<Navigate to="/admission-overview" replace />} />
          <Route path="/Home/AdmissionProcedure" element={<Navigate to="/admission-procedure" replace />} />
          <Route path="/Home/AdmissionFAQ" element={<Navigate to="/admission-faqs" replace />} />
          <Route path="/Home/CBSEBoardOfAffiliation" element={<Navigate to="/cbse-board-affiliation" replace />} />
          <Route path="/Home/MillenniumLearningSystem" element={<Navigate to="/millennium-learning-system" replace />} />
          <Route path="/Home/FacilitatorsDevelopment" element={<Navigate to="/facilitators-development" replace />} />
          <Route path="/Home/SchoolLife" element={<Navigate to="/school-life-overview" replace />} />
          <Route path="/Home/Sports" element={<Navigate to="/sports" replace />} />
          <Route path="/Home/MusicDance" element={<Navigate to="/music-and-dance" replace />} />
          <Route path="/Home/CreativeArts" element={<Navigate to="/creative-arts" replace />} />
          <Route path="/Home/Theatre" element={<Navigate to="/theatre" replace />} />
          <Route path="/Home/ClubsandHousecouncil" element={<Navigate to="/clubs-and-house-council" replace />} />
          <Route path="/Home/SocialOutreach" element={<Navigate to="/social-outreach" replace />} />
          <Route path="/Home/Facilities" element={<Navigate to="/facilities" replace />} />
          <Route path="/Home/ParentsPartners" element={<Navigate to="/parents-as-partners" replace />} />
          <Route path="/Home/ParentsSpeak" element={<Navigate to="/parents-speak" replace />} />
          <Route path="/Home/ReferFriend" element={<Navigate to="/refer-a-friend" replace />} />
          <Route path="/Home/ParentSchoolAssociation" element={<Navigate to="/parent-school-association" replace />} />
          <Route path="/Home/NewsEvents" element={<Navigate to="/news-and-events" replace />} />
          <Route path="/Home/Awards" element={<Navigate to="/awards" replace />} />
          <Route path="/Home/PhotoGallery" element={<Navigate to="/photo-gallery" replace />} />
          <Route path="/Home/VideoGallery" element={<Navigate to="/video-gallery" replace />} />
          <Route path="/Home/ContactUs" element={<Navigate to="/contactus" replace />} />
          <Route path="/Home/MandatoryDisclosure" element={<Navigate to="/mandatorydisclosure" replace />} />
          <Route path="/Home/Testimonials" element={<Navigate to="/testimonial" replace />} />
          <Route path="/Home/GalleryDetails/*" element={<Navigate to="/photo-gallery" replace />} />
          <Route path="/overview" element={<Overview />} />
          {/* <Route path="/AboutUs" element={<Overview />} /> */}
          <Route path="/visionValue" element={<VisionValue />} />
          <Route
            path="/researchdevelopment"
            element={<ResearchDevelopment />}
          />
          <Route path="/faq" element={<FAQ />} />

          {/* About Us Routes */}
          <Route path="/overview" element={<Overview />} />
          <Route path="/vision-values" element={<VisionValue />} />
          <Route path="/research-development" element={<ResearchDevelopment />} />
          <Route path="/faqs" element={<FAQ />} />

          {/* Admission Routes */}
          <Route path="/admission-overview" element={<AdmissionOverview />} />
          <Route path="/admission-procedure" element={<AdmissionProcedure />} />
          <Route path="/admission-faqs" element={<FAQadmission />} />

          {/* Scholastics Routes */}
          <Route path="/cbse-board-affiliation" element={<CBSEBoardOfAffiliation />} />
          <Route path="/millennium-learning-system" element={<TheMillenniumLearningSystem />} />
          <Route path="/facilitators-development" element={<FacilitatorsDevelopment />} />



          {/* School Life Routes */}
          <Route path="/school-life-overview" element={<SchoollifeOverview />} />
          <Route path="/sports" element={<Sports />} />
          <Route path="/music-and-dance" element={<MusicAndDance />} />
          <Route path="/creative-arts" element={<CreativeArts />} />
          <Route path="/theatre" element={<Theatre />} />
          <Route path="/clubs-and-house-council" element={<ClubsandHousecouncil />} />
          <Route path="/social-outreach" element={<SocialOutreach />} />
          <Route path="/facilities" element={<Facilities />} />


          {/* Parents' Corner Routes */}
          <Route path="/parents-as-partners" element={<ParentsAsPartners />} />
          <Route path="/parents-speak" element={<ParentsSpeak />} />
          <Route path="/refer-a-friend" element={<ReferAFriend />} />
          <Route path="/parent-school-association" element={<ParentSchoolAssociation />} />

          <Route path="/contactus" element={<ContactUs />} />

          {/* <Route path="/newsandevents" element={<NewsandEvents />} /> */}
          <Route path="/news-and-events" element={<NewsandEvents />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/photo-gallery" element={<PhotoGallery />} />
          <Route path="/video-gallery" element={<VideoGallery />} />

          <Route
            path="/mandatorydisclosure"
            element={<MandatoryDisclosure />}
          />
          <Route path="/careers" element={<Careers />} />

          <Route path="/innerGallary" element={<InnerGallary />} />
          <Route path="/gallery/:slug" element={<InnerGallary />} />
          <Route path="/testimonial" element={<Testimonial />} />
        </Routes>

        <Footer />
        <FloatingActions />
      </BrowserRouter>
    </>
  );
}

export default App;
